import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    background: '#ffff',
    borderRadius: 4,
    boxShadow: '0 1px 0 0 rgba(0,0,0,0.07)',
    width: '100%',
    //marginBottom: theme.spacing(2),
    position: 'relative',
    top: 0,
    zIndex: 15,
    textAlign: 'center',
  },
  '@media screen and (min-width: 600px)': {
    root: {
      background: '#ffff',
      borderRadius: 4,
      boxShadow: '0 1px 0 0 rgba(0,0,0,0.07)',
      position: 'sticky',
      bottom: 0,
      zIndex: 15,
      width: '100%',
      marginBottom: theme.spacing(2),
      padding: `0 0 0 ${theme.spacing(2)}px`,
    },
  },
  gridItemRight: {
    display: 'flex',
  },
}));
